/**
 * These enums are built our of two parts
 *   fetch progress: PENDING = WAITING or FETCHING
 *   result outcome: DONE = OK or ERROR
 * The four enums encompass the 4 possible combinations: simple vs detailed fetch info
 * and simple vs detailed result info
 */

export enum SimpleLoadStatus {
  PENDING = "PENDING",
  DONE = "DONE",
}

export enum DetailedLoadStatus {
  WAITING = "WAITING",
  FETCHING = "FETCHING",
  OK = "OK",
  ERROR = "ERROR",
}

export enum LoadStatusWithResponseDetail {
  PENDING = "PENDING",
  OK = "OK",
  ERROR = "ERROR",
}

export enum LoadStatusWithFetchDetail {
  WAITING = "WAITING",
  FETCHING = "FETCHING",
  DONE = "DONE",
}

export function removeFetchDetail(
  status: DetailedLoadStatus
): LoadStatusWithResponseDetail {
  switch (status) {
    case DetailedLoadStatus.OK:
      return LoadStatusWithResponseDetail.OK;
    case DetailedLoadStatus.ERROR:
      return LoadStatusWithResponseDetail.ERROR;
    default:
      return LoadStatusWithResponseDetail.PENDING;
  }
}

export function combineDetailedStatuses(
  statuses: DetailedLoadStatus[]
): DetailedLoadStatus {
  const allOk = statuses.reduce(
    (result, status) => result && status === DetailedLoadStatus.OK,
    true
  );
  const anyError = statuses.reduce(
    (result, status) => result || status === DetailedLoadStatus.ERROR,
    false
  );
  const anyFetching = statuses.reduce(
    (result, status) => result || status === DetailedLoadStatus.FETCHING,
    false
  );
  if (allOk) {
    return DetailedLoadStatus.OK;
  }
  if (anyError) {
    return DetailedLoadStatus.ERROR;
  }
  if (anyFetching) {
    return DetailedLoadStatus.FETCHING;
  }
  return DetailedLoadStatus.WAITING;
}

export function combineStatusesWithResponseDetail(
  statuses: LoadStatusWithResponseDetail[]
): LoadStatusWithResponseDetail {
  const allOk = statuses.reduce(
    (result, status) => result && status === LoadStatusWithResponseDetail.OK,
    true
  );
  const anyError = statuses.reduce(
    (result, status) => result || status === LoadStatusWithResponseDetail.ERROR,
    false
  );
  if (allOk) {
    return LoadStatusWithResponseDetail.OK;
  }
  if (anyError) {
    return LoadStatusWithResponseDetail.ERROR;
  }
  return LoadStatusWithResponseDetail.PENDING;
}
